<template>
  <div>
    <pricing-form />
  </div>
</template>

<script>
import PricingForm from '~/components/pricing-form'

export default {
  name: 'MembershipPricingForm',

  components: { PricingForm }
}
</script>

<style lang="scss" scoped></style>
